import React from "react";
import LegalPage from "./LegalPage";
import { SITE } from "@/lib/site";

export default function Refund() {
  return (
    <LegalPage
      path="/refund-policy"
      heading="Refund & Cancellation Policy"
      updated="September 2026"
      title="Refund & Cancellation Policy | Registry Feed"
      description="Registry Feed's refund and cancellation policy — including data-product refund rules, trial policy and support contact."
    >
      <h2>Nature of the product</h2>
      <p>Registry Feed sells access to a daily data feed. Because our datasets are digital, non-returnable, and time-sensitive, the following rules apply.</p>
      <h2>Before your subscription is activated</h2>
      <p>If you have paid but your subscription has not yet been activated on the dashboard, you may request a full refund by writing to <a href={`mailto:${SITE.salesEmail}`}>{SITE.salesEmail}</a> or messaging us on WhatsApp.</p>
      <h2>After activation</h2>
      <p>Once a subscription is activated and you have accessed any of the daily files, the subscription is considered consumed and is <strong>non-refundable</strong>. This is standard practice for time-sensitive data products.</p>
      <h2>Trial subscriptions</h2>
      <p>The 3-day Pan India trial is a discounted, promotional package. It is non-refundable once activated. It is designed so you can evaluate the data before committing to a longer subscription.</p>
      <h2>Cancellations</h2>
      <p>You may cancel your subscription at any time by writing to us. Cancellation stops future renewals; it does not, by itself, produce a refund for the current window.</p>
      <h2>Exceptional cases</h2>
      <p>If you have a legitimate concern — for example, if our platform was unavailable for a significant part of your subscription window due to our fault — write to <a href={`mailto:${SITE.salesEmail}`}>{SITE.salesEmail}</a>. We review each case in good faith.</p>
      <h2>Processing time</h2>
      <p>Approved refunds are processed to the original payment method within 7–14 working days.</p>
    </LegalPage>
  );
}
